/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CharCriteriaRequest
 */
export interface CharCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CharCriteriaRequest
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CharCriteriaRequest
     */
    exclude?: boolean;
}

export function CharCriteriaRequestFromJSON(json: any): CharCriteriaRequest {
    return CharCriteriaRequestFromJSONTyped(json, false);
}

export function CharCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharCriteriaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function CharCriteriaRequestToJSON(value?: CharCriteriaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'exclude': value.exclude,
    };
}


